/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, useMultiStyleConfig, Divider, Text} from '@chakra-ui/react'
import {MenuCardGroup} from './menu-card-group'
import TertiaryLink from './tertiary-link'
import {getGlobalLink} from '../../utils/contentstack-utils'
import {MenuCard} from './menu-card'

const ListMenuContent = ({secondLevel, categoriesData, onItemClick}) => {
    const styles = useMultiStyleConfig('KenwoodMenu')

    let exploreAllCard = null
    if (secondLevel?.show_explore_all_card) {
        const {url, label, isAbsolute} = getGlobalLink({
            link: secondLevel.explore_all_card.redirects,
            categoriesData,
        })
        exploreAllCard = (
            <MenuCard
                title={label}
                url={url}
                variant="exploreAll"
                isLink
                image={secondLevel.explore_all_card.image}
                isAbsolute={isAbsolute}
                handleClick={onItemClick}
            />
        )
    }

    let content = null
    if (secondLevel?.layout === 'Category') {
        content = (
            <Flex {...styles.categoryContainer}>
                <Box flexGrow="1">
                    <MenuCardGroup
                        group={secondLevel.standard_group[0]}
                        categoriesData={categoriesData}
                        onItemClick={onItemClick}
                        extraCard={exploreAllCard}
                    />
                </Box>
                <Divider orientation="vertical" {...styles.divider} />
                <MenuCardGroup
                    group={secondLevel.filters_group[0]}
                    categoriesData={categoriesData}
                    type="filter"
                    onItemClick={onItemClick}
                />
            </Flex>
        )
    }
    if (secondLevel?.layout === 'Promo/Gift') {
        content = (
            <Box {...styles.promoContainer}>
                <MenuCardGroup
                    group={secondLevel.promos_group[0]}
                    categoriesData={categoriesData}
                    type="promo"
                    onItemClick={onItemClick}
                />
            </Box>
        )
    }

    return (
        <Flex {...styles.contentContainer}>
            {content}
            {secondLevel?.footer?.tertiary_links?.length > 0 && (
                <Flex {...styles.footerContainer}>
                    <Divider {...styles.mainDivider} />
                    <Text
                        {...styles.footerTextHeader}
                        color={
                            secondLevel?.footer?.footer_label_hex_color || styles.footerText.color
                        }
                    >
                        {secondLevel?.footer?.explore_all_label}
                    </Text>
                    {secondLevel?.footer?.tertiary_links.map((link) => {
                        return (
                            <TertiaryLink
                                key={link.uid}
                                link={link}
                                categoriesData={categoriesData}
                                onClick={onItemClick}
                            />
                        )
                    })}
                </Flex>
            )}
        </Flex>
    )
}

ListMenuContent.propTypes = {
    secondLevel: PropTypes.object,
    categoriesData: PropTypes.object,
    categoryUrl: PropTypes.string,
    isCategoryUrlAbsoulte: PropTypes.bool,
    onItemClick: PropTypes.func,
}

export {ListMenuContent}
